
export type GetAggregatedMetrics401 = {
  error?: string;
};
